/* ============================================================
   VARELON — Scripts personnalisés
   1. Réparation de la largeur de page après fermeture du formulaire
   2. Bouton retour en haut de page
   ============================================================ */

/* ---------- 1. Réparation de la largeur de page ----------
   Horizon rétrécit la page (classe 'page-wrapper--drawer-open') tant qu'un
   tiroir est ouvert. EasySell cache le tiroir sans retirer son attribut
   'open' : on ne peut donc pas se fier à l'attribut, on vérifie si un tiroir
   est réellement VISIBLE à l'écran. */
(function () {
  function tiroirReellementVisible() {
    var tiroirs = document.querySelectorAll('theme-drawer');

    for (var i = 0; i < tiroirs.length; i++) {
      var tiroir = tiroirs[i];
      var dialogue = tiroir.querySelector('dialog');
      if (!dialogue) continue;
      if (!dialogue.open) continue;

      var boite = dialogue.getBoundingClientRect();
      if (boite.width < 5 || boite.height < 5) continue;

      var style = window.getComputedStyle(dialogue);
      if (style.display === 'none') continue;
      if (style.visibility === 'hidden') continue;
      if (parseFloat(style.opacity || '1') < 0.05) continue;

      return true;
    }
    return false;
  }

  function reparer() {
    var page = document.querySelector('.page-wrapper');
    if (!page) return;

    var doitEtreRetreci = tiroirReellementVisible();
    var estRetreci = page.classList.contains('page-wrapper--drawer-open');

    if (estRetreci && !doitEtreRetreci) {
      page.classList.remove('page-wrapper--drawer-open');
    }
  }

  setInterval(reparer, 250);

  var minuteur;
  var observateur = new MutationObserver(function () {
    clearTimeout(minuteur);
    minuteur = setTimeout(reparer, 80);
  });

  if (document.body) {
    observateur.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['open', 'class', 'style']
    });
  }
})();

/* ---------- 2. Retour en haut de page ---------- */
(function () {
  if (!document.body) return;

  var bouton = document.createElement('button');
  bouton.type = 'button';
  bouton.className = 'varelon-top';
  bouton.setAttribute('aria-label', 'Revenir en haut de la page');
  bouton.innerHTML =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';

  bouton.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  document.body.appendChild(bouton);

  function majVisibilite() {
    if (window.scrollY > 500) {
      bouton.classList.add('varelon-top--visible');
    } else {
      bouton.classList.remove('varelon-top--visible');
    }
  }

  majVisibilite();
  window.addEventListener('scroll', majVisibilite, { passive: true });
})();
